import { jsx as m } from "react/jsx-runtime";
import { useRef as g } from "react";
import { a as k } from "../../core-DVmjA3_O.js";
import { _ as h } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import u from "../../hooks/useSpacingToken.js";
import { paddingSpacings as b } from "../../utils/style.js";
import '../../index25.css';const p = "_heading_1obka_1", V = "_center-aligned_1obka_11", f = "_with-light-background_1obka_15", x = "_with-bottom-border_1obka_19", T = "_level-one_1obka_23", w = "_level-two_1obka_32", y = "_level-three_1obka_40", S = "_level-four_1obka_49", B = "_level-five_1obka_53", D = "_level-six_1obka_57", F = "_ellipsized_1obka_63", O = "_color-variant-text_1obka_73", z = "_color-variant-text-on-dark_1obka_77", N = "_color-variant-primary_1obka_81", A = "_color-variant-secondary_1obka_85", C = "_color-variant-success_1obka_89", L = "_color-variant-danger_1obka_93", e = {
  heading: p,
  centerAligned: V,
  withLightBackground: f,
  withBottomBorder: x,
  levelOne: T,
  levelTwo: w,
  levelThree: y,
  levelFour: S,
  levelFive: B,
  levelSix: D,
  ellipsized: F,
  colorVariantText: O,
  colorVariantTextOnDark: z,
  colorVariantPrimary: N,
  colorVariantSecondary: A,
  colorVariantSuccess: C,
  colorVariantDanger: L
}, P = {
  1: e.levelOne,
  2: e.levelTwo,
  3: e.levelThree,
  4: e.levelFour,
  5: e.levelFive,
  6: e.levelSix
}, H = {
  text: e.colorVariantText,
  primary: e.colorVariantPrimary,
  secondary: e.colorVariantSecondary,
  success: e.colorVariantSuccess,
  danger: e.colorVariantDanger,
  "text-on-dark": e.colorVariantTextOnDark
};
function J(l) {
  const {
    className: t,
    level: r = 3,
    children: a,
    ellipsize: i,
    centerAligned: c,
    variant: o = "container",
    spacing: s,
    colorVariant: n
  } = l, _ = u({
    spacing: s,
    modes: b
  }), d = `h${r}`, v = g(null);
  return a ? /* @__PURE__ */ m(
    d,
    {
      className: h(
        e.heading,
        i && e.ellipsized,
        P[r],
        k(n) && H[n],
        c && e.centerAligned,
        o === "form" && _,
        o === "form" && e.withBottomBorder,
        o === "form" && e.withLightBackground,
        t
      ),
      ref: v,
      children: a
    }
  ) : null;
}
export {
  J as default
};
